module.exports = __webpack_public_path__ + "img/undercover reporter.6c630076.png";